import { Skeleton, TableRow } from "@mui/material"
import { StyledTableCell } from "./CompactTable"

const TableLoadingSkeleton = (props: { tableHeaders: any[] }) => {
  const { tableHeaders } = props
  return (
    <>
      <TableRow>
        {
          tableHeaders.map((_: any, index: number) => {
            if (index === 0) {
              return (
                <StyledTableCell sx={{ paddingLeft: '1.5rem' }}>
                  <Skeleton variant="text" width={100} />
                </StyledTableCell>
              )
            }
            return (
              <StyledTableCell align="left">
                <Skeleton variant="text" width={100} />
              </StyledTableCell>
            )
          })
        }
      </TableRow>
      <TableRow>
        {
          tableHeaders.map((_: any, index: number) => {
            if (index === 0) {
              return (
                <StyledTableCell sx={{ paddingLeft: '1.5rem' }}>
                  <Skeleton variant="text" width={100} />
                </StyledTableCell>
              )
            }
            return (
              <StyledTableCell align="left">
                <Skeleton variant="text" width={100} />
              </StyledTableCell>
            )
          })
        }
      </TableRow>
      <TableRow>
        {
          tableHeaders.map((_: any, index: number) => {
            if (index === 0) {
              return (
                <StyledTableCell sx={{ paddingLeft: '1.5rem' }}>
                  <Skeleton variant="text" width={100} />
                </StyledTableCell>
              )
            }
            return (
              <StyledTableCell align="left">
                <Skeleton variant="text" width={100} />
              </StyledTableCell>
            )
          })
        }
      </TableRow>
    </>
  )
}

export default TableLoadingSkeleton